export default __webpack_public_path__ + "static/photo4-1c5690b39547f745c5256a33933a1d89.jpg";